import React from "react";
import Slider from "react-slick";

const Carousel = ({children, slidesToScroll, slidesToShow, className}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: slidesToShow || 1,
    slidesToScroll: slidesToScroll || 1,
    // adaptiveHeight: true,
    appendDots: dots => <ul className="custom-dots">{dots}</ul>
  };

  return (
    <div className={`${className}`}>
      <Slider {...settings}>
        {children}
      </Slider>
    </div>
  )
}

export { Carousel }